import React from "react";
import "./styles.scss";
import "./mobile.scss";

import { RiArrowRightLine, RiCheckLine } from "react-icons/ri";
import { RadioBox, TextWithIcon } from "../../index";
import { useDispatch } from "react-redux";
import productSelectionReducer from "../../../modules/product-selection/redux/product-selection.reducer";

const Index = (props) => {
  const dispatch = useDispatch();
  return (
    <>
      <div
        className={`product-item-card-wrapper d-flex flex-column mr-3
         ${props.type} ${props.size} ${props.isSelect ? "is_active" : ""}`}
      >
        <div className={`product-item-selected-icon  ${props.size}`} onClick={props.onClick}>
          <div className={`d-flex justify-content-center align-items-center animate__animated animate__fadeInUp`}>
            {props.isSelect && <RiCheckLine />}
          </div>
        </div>
        <div className={`pic-image-wrapper ${props.size}`}>
          <img className={"animate__animated animate__fadeIn"} src={props.img} alt="NTB online banking" />
        </div>
        <div className={`ps-card-title ${props.size}`}>{props.title}</div>
        <div className={`ps-card-body ${props.size}`}>{props.description}</div>

        <div
          className={`product-item-option-card d-flex align-items-center justify-content-between 
            ${props.size} `}
        >
          <div className={"mt-2"}>
            <div
              className={"pi-view-more-icon"}
              onClick={() => dispatch(productSelectionReducer.actions.setProductReadMore(props.product))}
            >
              <TextWithIcon size={"md"} text={"View more"} isIcon={false} icon={<RiArrowRightLine />} />
            </div>
          </div>
          <div className={"pi-select"}>
            <RadioBox
              onClick={props.onClick}
              isSelect={props.isSelect}
              text={props.isSelect ? "selected" : "select"}
              size={"md"}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Index;
